import script from "./pageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./pageLayout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__